import { render } from "./submodels.vue?vue&type=template&id=021251ac"
import script from "./submodels.vue?vue&type=script&lang=js"
export * from "./submodels.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__